import React from "react";
import { DatePicker, Spin } from "antd";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({ dateRange, onChange, loading = false }) => {
  return (
    <Spin spinning={loading}>
      <RangePicker
        value={dateRange}
        onChange={onChange}
        style={{ width: "100%" }}
        format="YYYY-MM-DD"
        allowClear
      />
    </Spin>
  );
};

export default DateRangeFilter;
